module.exports = __webpack_public_path__ + "assets/icon-archive.1c3419ca.svg";